<span matSnackBarLabel>
  New Notification
</span>
<span matSnackBarActions>
  <button mat-button matSnackBarAction (click)="snackBarRef.dismiss()">Dismiss</button>
  <button mat-button matSnackBarAction (click)="snackBarRef.dismissWithAction()">View</button>
</span>
